import React, { useMemo } from 'react';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { useQuickSearchAnalytics } from '../../../../../controllers/use-quick-search-analytics/index.tsx';

export const QuickSearchFireScreenAnalytics = () => {
	const [{ query }] = useQuickSearchAnalytics();
	const isSearch = useMemo(() => Boolean(query?.length), [query]);
	return (
		<ContextualAnalyticsData
			sourceName={isSearch ? 'searchCommandPalettePostQuery' : 'searchCommandPalettePreQuery'}
			sourceType={SCREEN}
		>
			<FireScreenAnalytics />
		</ContextualAnalyticsData>
	);
};
